if ($('#reviewsList').length) {
    $('#reviewsList').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        speed: 300,
        adaptiveHeight: true,
        centerPadding: '4vw',
        centerMode: true,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    arrows: true,
                    centerPadding: '12vw',
                }
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    centerPadding: '12vw',
                }
            },
            {
                breakpoint: 520,
                settings: {
                    arrows: false,
                    centerPadding: '12vw',
                }
            },
        ]
    });
}